import React, { ComponentType, PropsWithChildren } from 'react';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { Typography } from '@cp/ds/src/components/typography';
import { styled } from '@cp/ds/src/theme';
import { ErrorRender } from './error';

const Root = styled(Box, { name: 'Exception' })({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}) as unknown as ComponentType<BoxProps>;

export interface ExceptionProps extends BoxProps, PropsWithChildren {
  error?: Error;
  nextAction?: React.ReactNode;
}
export const Exception: React.FC<ExceptionProps> = ({ nextAction, children, error, ...props }) => {
  return (
    <Root {...props}>
      <Typography sx={{ textAlign: 'center', marginBlockEnd: 4 }} variant="h4">
        Кажется, что-то пошло не так...
      </Typography>
      <Typography sx={{ textAlign: 'center' }} variant="body">
        Мы уже работаем над исправлением ошибки
      </Typography>
      <Box>{nextAction}</Box>
      <Box sx={{ marginBlock: 2 }}>
        {children}
        {error && <ErrorRender error={error} />}
      </Box>
    </Root>
  );
};
